










































































































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import GuestReservationHistory from "@/shared/models/guestReservationHistory";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import DateField from "@/components/misc/DateField.vue";
import ReservationModal from "@/components/reservation-form/ReservationModal.vue";
import * as _ from "lodash";
import NoData from "@/components/misc/NoData.vue";
import RequireRole from "@/components/misc/RequireRole.vue";
import TableCellUnitTypeDisplay from "@/components/misc/TableCellUnitTypeDisplay.vue";
import { Getter } from "vuex-class";

@Component({
  components: {
    SortableHeadersTable,
    DateField,
    ReservationModal,
    NoData,
    RequireRole,
    TableCellUnitTypeDisplay
  },
})
export default class GuestReservationHistoryTable extends Vue {
    @PropSync("open", { default: false }) isOpen?: boolean;
    @Prop() customerId?: number;

    @Getter("appParams/reservationTenantUsesServiceTypes") tenantUsesServiceType?: boolean;

    settingsOpen = false;
    headers: SortableTableHeader[] = []
    setupHeaders() {
        this.headers = [
            {
                text: "Period",
                value: "period",
                active: true,
                default: false,
                class: "resize-header",
                exportHeaders: ["arrivalDate", "departureDate", "numberOfNights"],
            },
            {
                text: "Accomodation unit",
                value: "accomodationUnitTypeName",
                active: true,
                default: false,
                class: "resize-header",
                exportHeaders: [
                "accomodationUnitTypeName",
                "accomodationUnitName",
                "propertyName",
                ],
            },
            {
                text: "Reservation Id",
                value: "reservationId",
                active: true,
                default: false,
                class: "resize-header",
                exportHeaders: ["reservationId"],
            },
            {
                text: "Price per night",
                value: "pricePerNight",
                active: true,
                default: false,
                class: "resize-header",
                exportHeaders: ["pricePerNight", "currencyCode"],
            },
            ...(this.tenantUsesServiceType ? [
                {
                    text: "Service type",
                    value: "serviceTypeName",
                    active: true,
                    default: false,
                    class: "resize-header",
                    exportHeaders: ["serviceTypeName"],
                }
            ] : []),
            {
                text: "Actions",
                value: "actions",
                sortable: false,
                active: true,
                default: true,
                class: "resize-header",
                exportHeaders: [],
            },
        ];
    }

    created()  {
        this.setupHeaders();
    }    

    filters = {
        arrivalOrDepartureDate: "",
        accomodationUnitName: "",
        serviceTypeName: "",
        reservationId: ""
    };

    @Watch("filters", { deep: true })
    watchFilters(val: any, old: any) {
        if (_.isEqual(val, old) && this.isOpen) {
            this.options.page = 1;
            this.debouncedLoad();
        }
    }

    options: DataOptions = {
        page: 1,
        itemsPerPage: 25,
        sortBy: ["period"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true,
    };

    initLoaded = false;
    @Watch("options", { deep: true })
    watchOptions(fresh: DataOptions, old: DataOptions) {
        if ((!this.initLoaded || !_.isEqual(fresh, old)) && this.isOpen) {
            this.initLoaded = true;
            this.load();
        }
    }

    @Watch("open")
    openChanged(fresh: boolean) {
        if(fresh && this.customerId) {
            this.load();
        }
    }
    loading = true;

    debouncedLoad = _.debounce(this.load, 500);

    list: ListModel<GuestReservationHistory> = {
        count: 0,
        result: [],
    };

    async load(): Promise<ListModel<GuestReservationHistory>> {
        this.loading = true;
        return this.axios.get<ListModel<GuestReservationHistory>>("/reservations/GetGuestReservationHistory", {
            params: this.queryParams,
        })
        .then((res) => {
            this.list = res.data;
            return this.list;
        })
        .finally(() => {
            this.loading = false;
        });
    }

    get queryParams() {
        return {
            $skip: this.options.itemsPerPage * (this.options.page - 1),
            $top: this.options.itemsPerPage,
            $orderby: formatOrderbyArray(
                this.options.sortBy[0] == "period" ? ["arrivalDate"] : this.options.sortBy,
                this.options.sortDesc.map((x) => !x)
            ),
            $count: true,
            ...this.filters,
            customerId: this.customerId
        };
    }

    closeModal() {
      this.isOpen = false;
    }

}
